import React, { useEffect, useState } from 'react';
import { getLegalMarkdown } from '../api/client';
import { LegalMarkdown } from './LegalMarkdown';
import LegalPageShell, { LegalFallback } from '../components/celestial/LegalPageShell';

export default function TermsOfService() {
  const [markdown, setMarkdown] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getLegalMarkdown('terms-of-service')
      .then((text) => setMarkdown((text || '').trim()))
      .catch((e) => setError(e instanceof Error ? e.message : 'Metin yüklenemedi'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <LegalPageShell title="Kullanım Koşulları">
      {loading && <p>Yükleniyor…</p>}
      {error && <div className="celestial-error">{error}</div>}
      {markdown ? <LegalMarkdown content={markdown} /> : null}
      {!loading && !markdown && (
        <LegalFallback
          href="https://api.astroai.work/api/legal/terms-of-service"
          label="API bağlantısı"
        />
      )}
    </LegalPageShell>
  );
}
